/* copy.icon.svg.js */

module.exports = {
    icon: `    
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="foreground-gl" d="M15.0342 16.3794H4.53418C3.93418 16.3794 3.53418 15.9794 3.53418 15.3794V4.97935C3.53418 4.47935 4.03418 3.97935 4.53418 3.97935H15.0342C15.6342 3.97935 16.0342 4.37935 16.0342 4.97935V15.3794C16.0342 15.9794 15.5342 16.3794 15.0342 16.3794ZM5.63418 14.3794H14.0342V5.87935H5.63418V14.3794Z" fill="#5D6F80"/>
<path class="foreground-gl" d="M0.0842953 4.05595V6.05596H2.0843V4.05595H0.0842953ZM0.0842953 7.55596V9.55596H2.0843V7.55596H0.0842953ZM3.5843 0.555954V2.55595H5.58429V0.555954H3.5843ZM7.08429 0.555954V2.55595H9.0843V0.555954H7.08429ZM2.0843 0.555954C1.5343 0.555954 0.702129 0.543331 0.310462 0.934998C-0.0812047 1.32666 0.0842953 2.00595 0.0842953 2.55595H2.0843V0.555954ZM10.5843 0.555954V2.55595H12.5843C12.5843 2.00595 12.7494 1.32666 12.3577 0.934998C11.966 0.543331 11.1343 0.555954 10.5843 0.555954ZM0.0842953 11.1803C0.0842953 11.7303 -0.0812387 12.388 0.310428 12.7797C0.702095 13.1714 1.5343 13.1803 2.0843 13.1803V11.1803H0.0842953Z" fill="#5D6F80"/>
</svg>



`,
};
